import React from 'react'
import { Layout as RALayout } from 'react-admin'
import AppBar from './AppBar'
import Menu from './Menu'

const Layout = props => <RALayout {...props} appBar={AppBar} menu={Menu} style={{ paddingBottom: 50, minHeight: 'calc(100vh - 125px)' }} />

export default Layout
